module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.cbdf3ab9.otf";